"use strict";
import Vue from 'vue';
import axios from "axios";
import VueCookies from "vue-cookies";
import store from "../store"

Vue.use(VueCookies)
// Full config:  https://github.com/axios/axios#request-config
let token = Vue.$cookies.get('token')
let config = {
    baseURL: process.env.baseURL || process.env.apiUrl || process.env.VUE_APP_BASE_URL,
    // timeout: 60 * 1000, // Timeout
    withCredentials: true,
    headers: {
        Authorization: token,
        language: 'fa'
    },
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        store.commit("setLoading", true)
        return config;
    },
    function (error) {
        // Do something with request error
        store.commit("setLoading", false)
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        // Do something with response data
        store.commit("setLoading", false)
        store.dispatch("showSuccessResponse", response)
        return response;
    },
    function (error) {
        // Do something with response error
        store.dispatch("showResponseErrors", error)
        store.commit("setLoading", false)
        return Promise.reject(error);
    }
);

Plugin.install = function (Vue) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;
